import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CartItem = { id: number; quantity: number; };

const initialState: CartItem[] = [];

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart(state, action: PayloadAction<number>) {
      const existing = state.find(i => i.id === action.payload);
      if (existing) existing.quantity += 1;
      else state.push({ id: action.payload, quantity: 1 });
    },
    removeFromCart(state, action: PayloadAction<number>) {
      return state.filter(i => i.id !== action.payload);
    },
    clearCart(state) {
      return [];
    },
  },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer; 